import { types } from 'mobx-state-tree'

export const CountryMarkModel = types.model('CountryMarkModel', {
  countryId: types.number,
  hasPrice: types.boolean,
})
